import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { AnnotationPayload } from '@/services/conversations-service/conversations-service.types';
import {
  getAnalyticCall,
  postAnnotation,
} from '@/services/conversations-service/conversations-service';

interface UseAnnotationsProps {
  analytics_call_id: string;
  translate: string;
}
export const useAnalyticsCall = ({ analytics_call_id, translate }: UseAnnotationsProps) => {
  const queryClient = useQueryClient();

  const { mutate: addAnnotation, isPending: isAddingAnnotation } = useMutation({
    mutationFn: ({ message, start_second, end_second }: AnnotationPayload) =>
      postAnnotation({ analytics_call_id }, { message, start_second, end_second }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ReactQueryKeys.CONVERSATIONS({ analytics_call_id, translate }),
      });
    },
  });

  const {
    data: analyticsCall,
    isPending: analyticsCallIsPending,
    isFetching: analyticsCallIsFetching,
  } = useQuery({
    queryKey: ReactQueryKeys.CONVERSATIONS({ analytics_call_id, translate }),
    queryFn: () => getAnalyticCall({ analytics_call_id, translate }),
    staleTime: Infinity,
    placeholderData: (previousData) => previousData,
  });

  return { addAnnotation, analyticsCall, analyticsCallIsPending, analyticsCallIsFetching, isAddingAnnotation };
};
